import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagKP = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M24.999 0C17.422 0 10.632 3.371 6.048 8.696H43.95C39.365 3.37 32.576 0 25 0ZM43.95 41.304H6.048C10.632 46.63 17.422 50 24.998 50c7.578 0 14.367-3.371 18.952-8.696Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M46.33 11.958H3.67A24.882 24.882 0 0 0 0 25c0 4.78 1.342 9.246 3.67 13.043h42.66A24.882 24.882 0 0 0 50 25.002c0-4.78-1.342-9.246-3.67-13.043Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M15.38 34.62a9.62 9.62 0 1 0 0-19.239 9.62 9.62 0 0 0 0 19.238Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m15.381 15.38 2.159 6.643h6.996l-5.662 4.106 2.175 6.662-5.668-4.125-5.659 4.117 2.167-6.654-5.657-4.106h6.991l2.158-6.643Z"
}));
FlagKP.displayName = 'FlagKP';
export default withFlagWrapper(FlagKP);
//# sourceMappingURL=index.js.map